import React from "react";
import { useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import "./footer-links-theme-2.scss";

function isExternalUrl(url) {
  return (
    url.startsWith("http") || url.startsWith("https") || url.startsWith("www")
  )
}

function getUrl(el) {
  function processUrl(url) {
    if (isExternalUrl(url)) {
      return url
    }
    return `/${url}`
  }

  if (el.has_link === "1") {
    return processUrl(el.url)
  }

  if (el.is_open_self === "0") {
    if (el.new_page_id === "") {
      return processUrl(el.url)
    }
    return `/custom-pages/${el.new_page_id}`
  }

  if (el.is_text === "1") {
    if (el.new_page_id === "") {
      return `/pages/${el.url}`
    }
    return `/custom-pages/${el.new_page_id}`
  }

  if (el.new_page_id === "") {
    return processUrl(el.url)
  }

  return `/custom-pages/${el.new_page_id}`
}

function CustomLink({el}) {
  const url = getUrl(el)
  const externalUrl = isExternalUrl(url)
  const target = el.is_open_self === "0" ? "" : "_blank"

  if (externalUrl) {
    return (
      <li>
        <a href={url} target={target} rel="noreferrer">
          {el.name}
        </a>
      </li>
    )
  }

  return (
    <li>
      <Link to={url} target={target}>
        {el.name}
      </Link>
    </li>
  )
}

const FooterLinksTheme2 = () => {
  const footerSectionData = useSelector(
    ({ common }) => common.commonDetailsData.footer_section
  );

  const supportData = useSelector(
    ({ common }) => common.commonDetailsData.header_section
  );

  return (
    <footer>
      <div className="container">
        <div className="grid">
          {supportData && (
            <div className="grid-items">
              <div className="footer-logo">
                {supportData.rsa_client_logo ? (
                  <NavLink to="/">
                    <img
                      src={supportData.rsa_client_logo}
                      alt={supportData.image_alt_text}
                    />
                  </NavLink>
                ) : (
                  ""
                )}
              </div>
              <div className="question">
                <p>
                  {supportData.support_question_title1
                    ? supportData.support_question_title1
                    : ""}
                </p>

                <a href={`tel:${supportData.support_contact_number}`}>
                  {" "}
                  {supportData.support_contact_number
                    ? supportData.support_contact_number
                    : ""}
                </a>
                <SupportTime text={supportData?.support_time} />
                <SupportTime text={supportData?.store_support_time2} />
                <SupportTime text={supportData?.store_support_time3} />
              </div>
              <div className="offer">
                {supportData.support_email ? (
                  <a
                    href={`mailto:${supportData.support_email}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {supportData.support_email}
                  </a>
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
    
          {footerSectionData && (
            <div className="grid-items">
              <div className="sub-grid">
                <div className="sub-grid-items">
                  <h3>
                    {footerSectionData?.my_account_section?.title
                      ? footerSectionData?.my_account_section?.title
                      : ""}
                  </h3>
                  <ul>
                    {footerSectionData?.my_account_section?.pages &&
                      footerSectionData?.my_account_section?.pages
                        ?.filter((fls) => fls.has_visible === "1")
                        ?.map((el, index) => <CustomLink key={index} el={el} />)}
                  </ul>
                </div>
                <div className="sub-grid-items">
                  <h3>
                    {footerSectionData?.help_section?.title
                      ? footerSectionData?.help_section?.title
                      : ""}
                  </h3>
                  <ul>
                    {footerSectionData?.help_section?.pages &&
                      footerSectionData?.help_section?.pages
                        ?.filter((fls) => fls.has_visible === "1")
                        ?.map((el, index) => <CustomLink key={index} el={el} />)}
                  </ul>
                </div>
                <div className="sub-grid-items">
                  <h3>
                    {footerSectionData?.company_section?.title
                      ? footerSectionData?.company_section?.title
                      : ""}
                  </h3>
                  <ul>
                    {footerSectionData?.company_section?.pages &&
                      footerSectionData?.company_section?.pages
                        ?.filter((fls) => fls.has_visible === "1")
                        ?.map((el, index) => <CustomLink key={index} el={el} />)}
                  </ul>
                </div>

                {footerSectionData?.shopping_services_section?.title && footerSectionData?.shopping_services_section?.pages?.length > 0 &&
                  <div className="sub-grid-items">
                    <h3> {footerSectionData?.shopping_services_section?.title
                      ? footerSectionData?.shopping_services_section?.title
                      : ""}</h3>
                    <ul>
                      {footerSectionData?.shopping_services_section?.pages &&
                        footerSectionData?.shopping_services_section?.pages
                          ?.filter((fls) => fls.has_visible === "1")
                          ?.map((el, index) => <CustomLink key={index} el={el} />)}
                    </ul>
                  </div>
                }
              </div>
            </div>
          )}
        </div>
      </div>
    </footer >
  );
};

function SupportTime({text}) {
  if (!text) return null

  return (
    <div className="text-time">
      <span>{text}</span>
    </div>
  )
}

export default FooterLinksTheme2;
